var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtgs2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 57,
    viewBox: "0 0 78 57",
    width: 78,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .733875h77.8574478v56.266125h-77.8574478z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2e6fb7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m74.9436448 53.5140938h-72.02913435v-45.46225005l35.31064175 28.41450005c.4315523.3479375.981015.34675 1.410209 0l35.3082836-28.41450005zm-1.1472687-49.29431255-34.8661194 28.06062495-34.8684776-28.06062495zm2.6046418-3.4865h-74.94270148c-.80414926 0-1.45855224.781375-1.45855224 1.74325v52.78081245c0 .9606876.65440298 1.7432501 1.45855224 1.7432501h74.94270148c.8041493 0 1.4573731-.7825625 1.4573731-1.7432501v-52.78081245c0-.961875-.6532238-1.74325-1.4573731-1.74325z",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.0358761 51h7.9294723c.5705889 0 1.0346516-.4628383 1.0346516-1.0358761v-7.9282478c0-.5730378-.4640627-1.0358761-1.0346516-1.0358761h-.378352c-.5730378 0-1.035876.4628383-1.035876 1.0358761v5.4793682c0 .5730378-.4640627 1.0358761-1.0346517 1.0358761h-5.4805926c-.5730378 0-1.0358761.4640627-1.0358761 1.035876v.3771275c0 .5730378.4628383 1.0358761 1.0358761 1.0358761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9641239 48.5511204h-5.4805926c-.57058897 0-1.03465166-.4628383-1.03465166-1.0358761v-5.4793682c0-.5730378-.46283825-1.0358761-1.03587609-1.0358761h-.3783519c-.57058896 0-1.03465165.4628383-1.03465165 1.0358761v7.9282478c0 .5730378.46406269 1.0358761 1.03465165 1.0358761h7.92947225c.5730378 0 1.0358761-.4628383 1.0358761-1.0358761v-.3771275c0-.5718133-.4628383-1.035876-1.0358761-1.035876"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtgs2);
export default __webpack_public_path__ + "static/media/htgs_2.d3785a1eb18b7d1d387d66860cddd7fb.svg";
export { ForwardRef as ReactComponent };